export type Field = { title: string; accessor: string; type?: string };
export type SelectedDeviceAccessor = { id: string; title: string; fields: Field[] };

export const selectedDeviceAccessors: SelectedDeviceAccessor[] = [
  {
    id: 'device',
    title: 'Static Device Parameters',
    fields: [
      { title: 'Device ID', accessor: 'deviceId' },
      { title: 'Device Type', accessor: 'deviceType' },
      { title: 'Suspended Device', accessor: 'deviceStatus', type: 'checkbox' },
      { title: 'Enable Engineering Swaps', accessor: 'isSwapsEnabled', type: 'checkbox' },
      { title: 'Onboarded Date', accessor: 'createdTime' },
      { title: 'Last Updated ID', accessor: 'lastUpdatedBy' },
      { title: 'Last Suspension Update User ID', accessor: 'lastDisabledBy' },
      { title: 'Detail Device Type', accessor: 'detailedDeviceType' },
    ],
  },
  {
    id: 'device',
    title: 'Dynamic Device Parameters',
    fields: [
      { title: 'Asset Make', accessor: 'assetMake' },
      { title: 'Asset Serial Number', accessor: 'assetSerialNumber' },
      { title: 'Device Serial Number', accessor: 'deviceSerialNumber' },
      { title: 'Software Part Number', accessor: 'softwarePartNumber' },
    ],
  },
  {
    id: 'cellRadio',
    title: 'Cellular Radio Parameters',
    fields: [
      { title: 'Cellular Radio Type', accessor: 'radio.cellRadio.radioType' },
      { title: 'Cellular Radio Serial Number', accessor: 'radio.cellRadio.deviceSerialNumber' },
      { title: 'Cellular Port', accessor: 'radio.cellRadio.port' },
      { title: 'Cellular IMEI', accessor: 'radio.cellRadio.IMEI', type: 'text' },
      { title: 'MEID', accessor: 'radio.cellRadio.MEID', type: 'text' },
      { title: 'Cellular Software Part Number', accessor: 'radio.cellRadio.softwarePartNumber' },
      { title: 'Cellular Hardware Part Number', accessor: 'radio.cellRadio.hardwarePartNumber' },
      { title: 'Cellular Timestamp', accessor: 'radio.cellRadio.updatedTime' },
      { title: 'Cellular ICCID', accessor: 'radio.cellRadio.ICCID', type: 'text' },
      { title: 'IMSI', accessor: 'radio.cellRadio.IMSI', type: 'text' },
      { title: 'MDN', accessor: 'radio.cellRadio.MDN', type: 'text' },
      { title: 'ESN', accessor: 'radio.cellRadio.ESN', type: 'text' },
      { title: 'CDMA Preferred', accessor: 'isCDMAPreferred', type: 'checkbox' },
      { title: 'Cellular Radio Device ID', accessor: 'radio.cellRadio.deviceId'},
    ],
  },
  {
    id: 'satRadio',
    title: 'Satellite Radio Parameters',
    fields: [
      { title: 'Satellite Radio Type', accessor: 'radio.satRadio.radioType' },
      { title: 'Satellite Radio Serial Number', accessor: 'radio.satRadio.deviceSerialNumber' },
      { title: 'Satellite Port', accessor: 'radio.satRadio.port' },
      { title: 'Satellite IMEI', accessor: 'radio.satRadio.IMEI', type: 'text' },
      { title: 'MSISDN', accessor: 'radio.satRadio.MSISDN', type: 'text' },
      {
        title: 'Satellite Software Part Number',
        accessor: 'radio.satRadio.softwarePartNumber',
      },
      {
        title: 'Satellite Hardware Part Number',
        accessor: 'radio.satRadio.hardwarePartNumber',
      },
      { title: 'Satellite Timestamp', accessor: '' },
      { title: 'Satellite ICCID', accessor: 'radio.satRadio.ICCID', type: 'text' },
      { title: 'Satellite Radio Device ID', accessor: 'radio.satRadio.deviceId'},
    ],
  },
];

const newValue = { title: 'Disable ORB', accessor: 'isRadioDropEnabled', type: 'checkbox' };
export const selectedDeviceAccessorsORB = selectedDeviceAccessors.map(item =>
  item.title === 'Static Device Parameters' ?
    { ...item, fields: [...item.fields.slice(0, 5), newValue, ...item.fields.slice(5)] }
    : { ...item }
)
